import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'

export const C1ToggleButtonGroupTheme: Components<Theme>['MuiToggleButtonGroup'] = {
    defaultProps: {
        size: 'small',
        color: 'primary',
    },
    styleOverrides: {
        grouped: ({ theme }) => theme.unstable_sx({
            maxHeight: '30px',
        }),
    },
}
export const C1ToggleButtonTheme: Components<Theme>['MuiToggleButton'] = {
    styleOverrides: {
        root: ({ theme }) => theme.unstable_sx({
            textTransform: 'none',
            borderColor: 'info.main',
            color: 'info.main',

            '&:hover:not(.Mui-disabled)': {
                backgroundColor: 'info.extraLight',
                borderColor: 'info.dark',
            },

            '&:focus-visible': {
                backgroundColor: 'info.extraLight',
                borderColor: 'info.dark',
                outline: '2px solid',
                outlineColor: 'primary.main',
                outlineOffset: '2px',
                zIndex: 1,
            },

            '&.Mui-disabled': {
                borderColor: 'grey.600',
                color: 'grey.600', // Should be text.disabled, but that does not have sufficient contrast
                opacity: 0.6,
            },

            '&.Mui-selected': {
                backgroundColor: 'primary.extraLight',
                borderColor: 'primary.main',
                color: 'primary.dark',

                '&.Mui-disabled': {
                    backgroundColor: 'transparent',
                    borderColor: 'grey.600',
                    color: 'grey.600', // Should be text.disabled, but that does not have sufficient contrast
                },
            },
        }),
    },
}
